import { requestService as api } from "../Request.service"  
const API_URL = { 
  API_MANAGE: `/ERP/purchaseorder/manage.php`, 
  API_SEARCH: `/ERP/purchaseorder/search.php`, 

  API_GETCODE: `/ERP/purchaseorder/get-doc-code.php`,
  API_CHECKCODE: `/ERP/purchaseorder/check-pocode.php`,
  API_SERVICE: `/ERP/purchaseorder/service-master.php`,
};
  
const POService = () => { 
  
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (code) => api.get(`${API_URL.API_MANAGE}?code=${code}`);

  const code = () => api.get(`${API_URL.API_GETCODE}`);

  /* เช็ครหัสใบสั่งซื้อซ้ำ ใช้เตือนตอนกรอกในหน้าสร้าง */
  const checkCode = (poCode) =>
    api.get(`${API_URL.API_CHECKCODE}?code=${encodeURIComponent(poCode)}`, { ignoreLoading: true });

  /* ทะเบียนค่าบริการเพิ่ม (ใช้เฉพาะในหน้าใบสั่งซื้อ) */
  const serviceList = () => api.get(`${API_URL.API_SERVICE}`, { ignoreLoading: true });
  const serviceAdd = (code, name) => api.post(`${API_URL.API_SERVICE}`, { code, name });
  const serviceUpdate = (code, name, new_code) =>
    api.put(`${API_URL.API_SERVICE}`, { code, name, new_code, active: 1 });
  const serviceDelete = (code) =>
    api.delete(`${API_URL.API_SERVICE}?code=${encodeURIComponent(code)}`);

  const search = (parm = {}, config = {}) => api.post(`${API_URL.API_SEARCH}`, parm, {...config, cancle: true});
  

  return {
    create,
    update,
    deleted,
    get, 

    code,
    checkCode,

    search,

    serviceList,
    serviceAdd,
    serviceUpdate,
    serviceDelete,
  };
};

export default POService;